import baseURL from '../common/axios';
class SupplierBranchMappingservices {

    insert(dataModel) {
        return baseURL.httpMSInventoryUrl.post("SupplierBranchMapping/Create", dataModel)
    }
    update(dataModel) {
        return baseURL.httpMSInventoryUrl.post("SupplierBranchMapping/Update", dataModel)
    }
    delete(Id) {
        return baseURL.httpMSInventoryUrl.delete("SupplierBranchMapping/Delete?id=" + Id)
    }
    //Active
    active(Id, Status) {
        return baseURL.httpMSInventoryUrl.put("SupplierBranchMapping/Active?id=" + Id + "&Status=" + Status + "")
    }
    getById(Id) {
        return baseURL.httpMSInventoryUrl.get("SupplierBranchMapping/Get?SupplierId=" + Id)
    }

}
export default new SupplierBranchMappingservices()